import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { downloadFile } from 'utils/file'
import { DOWNLOAD_TAGS } from './query'
import { Data, UseDownloadTags, UseDownloadTagsProps, Variables } from './types'

export const useDownloadTags = ({ id, name, tagKind }: UseDownloadTagsProps): UseDownloadTags => {
  const [enabled, setEnabled] = useState(false)

  const { refetch } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const { downloadTags: file } = data
      const blob = new Blob([file.data], { type: file.type })

      const filename: string = `${name} - ${tagKind}.txt`
      downloadFile(blob, filename)
    },
    options: {
      enabled,
      staleTime: Infinity,
    },
    query: DOWNLOAD_TAGS,
    variables: {
      domainId: id,
      tagsType: tagKind,
    },
  })

  const lazyDownload = async (): Promise<void> => {
    setEnabled(true)

    await refetch()

    setEnabled(false)
  }

  return { lazyDownload }
}
